import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Tooltip } from "@mui/material";
function hexToRgba(hex, alpha) {
    let c = hex.replace("#", "");
    if (c.length === 3)
        c = c
            .split("")
            .map((x) => x + x)
            .join("");
    const num = parseInt(c, 16);
    return `rgba(${(num >> 16) & 255}, ${(num >> 8) & 255}, ${num & 255}, ${alpha})`;
}
export const StatProgressBar = ({ label, value, percent, color = "#1976d2", bgColor, height = 34, barWidth = 120, labelFontWeight = 500, labelFonts = "body2", labelColor = "#161C24", }) => {
    const filledWidth = percent;
    const defaultBgColor = hexToRgba(typeof color === "string" && color.startsWith("linear") ? "#1976d2" : color, 0.15);
    const nonFilledBg = bgColor || defaultBgColor;
    return (React.createElement(Tooltip, { arrow: true, placement: "top", title: React.createElement("span", null, value) },
        React.createElement(Box, { sx: {
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                width: "100%",
                minWidth: barWidth,
            } },
            React.createElement(Typography, { variant: labelFonts, color: labelColor, sx: {
                    fontWeight: labelFontWeight,
                    mb: 0.5,
                } }, label),
            React.createElement(Box, { sx: {
                    display: "flex",
                    width: "100%",
                    height: height,
                    borderRadius: 1,
                    gap: 0.5,
                } },
                React.createElement(Box, { sx: {
                        width: `${filledWidth}%`,
                        minWidth: 0,
                        height: "100%",
                        background: color,
                        display: "flex",
                        alignItems: "center",
                        pl: 1.5,
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: 14,
                        transition: "width 0.3s",
                        borderRadius: 1,
                    } }),
                React.createElement(Box, { sx: {
                        width: `${100 - filledWidth}%`,
                        minWidth: 0,
                        height: "100%",
                        background: nonFilledBg,
                        borderRadius: 1,
                    } })))));
};
